import React, { useEffect,useContext } from 'react';
import { useLocation } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import useNavigateNext from './useNavigateNext';
import { useAuth } from '../../auth/AutoContextProvider';
import { AuthContext } from '../../auth/AutoContextProvider';
import RefreshAuthenticationModal from '../modals/refreshAuthenticationModal';

function Protected({ isAuthenticated, children }) {
  const {state} = useContext(AuthContext)
  const [_, {getCookie}]= useAuth()
  const location = useLocation();
  const [searchParams, navigateNext] = useNavigateNext(location);
  const searchUrlParams = new URLSearchParams(location.search);

  const userType = searchUrlParams.get('user_type') || getCookie('tkn-ath-role')
  const fromLocation = searchUrlParams.get('from_location')

  useEffect(() => {
    if (isAuthenticated && userType == 'guest') {
      // const nextUrl = location.pathname;
      // navigateNext('/Login', {
      //   next: isAuthenticated ? '/' : nextUrl,
      // });
    }
    else if(!isAuthenticated && userType == 'guest' && fromLocation == 'webflow'){
      navigateNext('/TypeForm?from_location=webflow')
    }
  }, [isAuthenticated, location.pathname, navigateNext]);

  if (!isAuthenticated) {
    return(
      <DashboardLayout>
        <RefreshAuthenticationModal/>
        {children}
      </DashboardLayout>
    ) // Render nothing while redirecting
  }

  return (
    <DashboardLayout>
      {children}
    </DashboardLayout>
  );
}

export default Protected;
